import {
  Component,
  Output,
  ViewEncapsulation,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  OpsSubscriptionModalService,
  SubscriptionStatus,
} from '@ops/shared-types';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ops-subscription-message-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ops-subscription-message-modal.component.html',
  styleUrls: ['./ops-subscription-message-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OpsSubscriptionMessageModal implements OnInit, OnDestroy {
  @Input() status: string = '';
  @Input() statusType: SubscriptionStatus = SubscriptionStatus.SUCCESS;
  @Input() modalTitle: string = 'Subscription Status';
  @Input() modalText: string = '';

  @Output() confirmed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  private modalStateSubscription!: Subscription;

  constructor(private modalService: OpsSubscriptionModalService) {}

  get isError() {
    return this.statusType === SubscriptionStatus.ERROR;
  }

  get isConfirmation() {
    return this.statusType === SubscriptionStatus.CONFIRMATION;
  }

  ngOnInit(): void {
    this.modalStateSubscription = this.modalService
      .getModalState()
      .subscribe((state) => {
        if (state.config) {
          this.statusType = state.config.statusType;
          this.modalTitle = state.config.modalTitle || 'Subscription Status';
          this.modalText = state.config.modalText;
        }
      });
  }

  ngOnDestroy(): void {
    if (this.modalStateSubscription) {
      this.modalStateSubscription.unsubscribe();
    }
  }

  onConfirm(confirmed: boolean): void {
    this.confirmed.emit(true);
    this.modalService.confirm(true);
  }

  onClose(): void {
    this.closeModal.emit();
    this.modalService.closeModal();
  }
}
